<agr-page-toolbar
  [pageTitle]="'reference-value-sheet.overview.title' | translate"
  [hasPrimaryAction]="isAdvisor"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="createRefValSheet()"
  [hasSecondaryAction]="true"
  secondaryActionIcon="file_upload"
  [secondaryActionText]="'reference-value-sheet.overview.import-rvs' | translate"
  (secondaryAction)="uploadCSV()"
  [emptyTitle]="'reference-value-sheet.overview.empty.title' | translate"
  [emptyDescription]="'reference-value-sheet.overview.empty.description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
  [isEmpty]="(refValSheets$ | async)?.length === 0"
  data-test="value-sheet__overview"
>
  <ng-container actions>
    <button
      mat-flat-button
      class="spacing--margin-right"
      (click)="downloadTemplate()"
      data-test="value-sheet__download-template-button"
    >
      <mat-icon>file_download</mat-icon>
      <span>{{ 'reference-value-sheet.overview.download-template' | translate }}</span>
    </button>
  </ng-container>

  <div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
    <agr-table [config]="tableConfig"> </agr-table>
    <ng-template #columnActiveTemplate let-row="row">
      <mat-slide-toggle
        [hideIcon]="true"
        data-test="value-sheet__overview-toggle-active"
        color="primary"
        [disabled]="!isAdvisor"
        [checked]="row.isActive"
        (change)="onToggleActive(row)"
      >
      </mat-slide-toggle>
    </ng-template>
    <ng-template #columnNameTemplate let-row="row">
      <button
        mat-button
        class="button--text"
        (click)="onViewRefValSheet(row)"
        [attr.data-test]="'value-sheet__view-button_' + row.name"
      >
        {{ row.name }}
      </button>
    </ng-template>
  </div>
</agr-page-toolbar>
